import { type RichText, zRichText } from "@spz/shared-domain";

export const isRichTextValue = (value: unknown): value is RichText => {
  const parseResult = zRichText.safeParse(value);
  return parseResult.success;
};
